module.exports = __webpack_public_path__ + "img/upload.5a22a55f.svg";